import { Switch } from '@material-ui/core'
import { useUser } from 'components/providers/UserProvider'
import { editUserAttribute } from 'lib/api'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const TutorialsPresenter = (): JSX.Element => {
  const { t } = useTranslation()
  const { user, setUser } = useUser()
  const [listingTour, setListingTour] = useState(
    user.enabledNotifications?.displayListingTour ?? false
  )
  const [taxationTour, setTaxationTour] = useState(
    user.enabledNotifications?.displayPurchaseEventsTour ?? false
  )

  const handleDisplayListingTour = async () => {
    const notifications = user.enabledNotifications ?? {}
    const response = await editUserAttribute(
      {
        ...notifications,
        displayListingTour: !listingTour,
      },
      'enabledNotifications'
    )
    setUser({ ...user, ...response })
    setListingTour(!listingTour)
  }

  const handleDisplayTaxationTour = async () => {
    const notifications = user.enabledNotifications ?? {}
    const response = await editUserAttribute(
      {
        ...notifications,
        displayPurchaseEventsTour: !taxationTour,
      },
      'enabledNotifications'
    )
    setUser({ ...user, ...response })
    setTaxationTour(!taxationTour)
  }

  return (
    <>
      <div className="d-flex flex-row align-items-center">
        <span>{t('common.showListingTutorial')}</span>
        <Switch
          name={t('account.displayTour')}
          checked={listingTour}
          onChange={handleDisplayListingTour}
        />
      </div>

      {user.featureFlags?.taxation && (
        <div className="d-flex flex-row align-items-center mt-2">
          <span>{t('common.showTaxationTutorial')}</span>
          <Switch
            name={t('account.displayTour')}
            checked={taxationTour}
            onChange={handleDisplayTaxationTour}
          />
        </div>
      )}
    </>
  )
}
